/* Xclusive Nova wishlist. Built in house, no app: saved pieces live in the shopper's
   browser (localStorage, key "xn-wishlist", a list of product handles, newest first).
   Hooks: [data-xn-wish="handle"] toggles a piece, [data-xn-wish-count] shows the count,
   [data-xn-wishlist-page] renders the Wishlist page. */
(function () {
  if (window.XNWish) return;
  const KEY = 'xn-wishlist';
  const W = (window.XNWish = {});

  function read() {
    try {
      const v = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v.filter(h => typeof h === 'string') : [];
    } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    sync();
  }
  W.list = read;
  W.has = h => read().includes(h);
  W.toggle = function (h) {
    const list = read();
    const i = list.indexOf(h);
    if (i > -1) list.splice(i, 1); else list.unshift(h);
    write(list);
    return i === -1;
  };
  W.remove = function (h) { write(read().filter(x => x !== h)); };

  function sync() {
    const list = read();
    document.querySelectorAll('[data-xn-wish]').forEach(b => {
      const on = list.includes(b.dataset.xnWish);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      const t = b.querySelector('[data-xn-wish-text]');
      if (t) t.textContent = on ? 'Saved to wishlist' : 'Save to wishlist';
    });
    document.querySelectorAll('[data-xn-wish-count]').forEach(el => {
      el.textContent = list.length ? '(' + list.length + ')' : '';
    });
    document.querySelectorAll('[data-xn-wish-link]').forEach(a => {
      a.setAttribute('aria-label', 'Wishlist' + (list.length ? ', ' + list.length + (list.length === 1 ? ' piece' : ' pieces') : ''));
    });
  }
  W.sync = sync;

  /* ---------- Wishlist page ---------- */
  function money(cents, format) {
    const n = cents / 100;
    const withDelims = (num, dec, thou, dp) => {
      const [i, d] = num.toFixed(dp).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, thou) + (d ? dec + d : '');
    };
    return (format || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      switch (k) {
        case 'amount_no_decimals': return withDelims(n, '.', ',', 0);
        case 'amount_with_comma_separator': return withDelims(n, ',', '.', 2);
        case 'amount_no_decimals_with_comma_separator': return withDelims(n, ',', '.', 0);
        default: return withDelims(n, '.', ',', 2);
      }
    });
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }
  function img(src, width) {
    if (!src) return '';
    try {
      const u = new URL(src.startsWith('//') ? 'https:' + src : src, location.href);
      u.searchParams.set('width', width);
      return u.toString();
    } catch (e) { return src; }
  }
  function card(p, format) {
    const words = String(p.title).split(' ');
    const name = words.shift();
    const garment = words.join(' ');
    const src = p.featured_image || (p.images && p.images[0]);
    return '<li class="xn-wishcard">' +
      '<a class="xn-card" href="' + esc(p.url || '/products/' + p.handle) + '">' +
        '<div class="xn-card__media">' +
          (p.available ? '' : '<span class="xn-card__tag">Waitlist</span>') +
          (src ? '<img src="' + esc(img(src, 720)) + '" srcset="' + esc(img(src, 360)) + ' 360w, ' + esc(img(src, 540)) + ' 540w, ' + esc(img(src, 720)) + ' 720w, ' + esc(img(src, 900)) + ' 900w" sizes="(min-width: 860px) 33vw, 50vw" loading="lazy" alt="' + esc(p.title) + '">' : '') +
        '</div>' +
        '<div class="xn-card__info"><span class="xn-card__name">' + esc(name) + '</span><span class="xn-price">' + esc(money(p.price, format)) + '</span>' +
        (garment ? '<span class="xn-card__garment">' + esc(garment.charAt(0).toUpperCase() + garment.slice(1).toLowerCase()) + '</span>' : '') + '</div>' +
      '</a>' +
      buy(p) +
      '<button class="xn-wishcard__remove" type="button" data-xn-wish-remove="' + esc(p.handle) + '">Remove<span class="xn-sr"> ' + esc(p.title) + '</span></button>' +
    '</li>';
  }
  /* Add to cart straight from the wishlist. The piece stays saved. */
  function buy(p) {
    const vs = (p.variants || []).filter(v => v.available);
    if (!vs.length) return '<a class="xn-btn xn-btn--ghost xn-wishcard__cta" href="' + esc(p.url || '/products/' + p.handle) + '">Join the waitlist</a>';
    const single = p.variants.length === 1;
    return '<div class="xn-wishcard__buy" data-xn-wish-buy>' +
      (single ? '<input type="hidden" data-xn-wish-variant value="' + vs[0].id + '">' :
        '<label class="xn-sr" for="xn-wv-' + p.id + '">Size for ' + esc(p.title) + '</label>' +
        '<select class="xn-wishcard__size" id="xn-wv-' + p.id + '" data-xn-wish-variant>' +
          '<option value="">Select a size</option>' +
          p.variants.map(v => '<option value="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + esc(v.title) + (v.available ? '' : ', sold out') + '</option>').join('') +
        '</select>') +
      '<button class="xn-btn xn-wishcard__cta" type="button" data-xn-wish-add' + (single ? '' : ' disabled') + '>' + (single ? 'Add to cart' : 'Select a size') + '</button>' +
      '<p class="xn-wishcard__msg" data-xn-wish-msg role="status"></p>' +
    '</div>';
  }
  async function addToCart(box) {
    const btn = box.querySelector('[data-xn-wish-add]');
    const id = box.querySelector('[data-xn-wish-variant]').value;
    const msg = box.querySelector('[data-xn-wish-msg]');
    if (!id) return;
    const base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    btn.disabled = true; btn.textContent = 'Adding';
    try {
      const r = await fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }) });
      const data = await r.json();
      if (!r.ok) throw new Error(data.description || data.message || 'Could not add');
      const cart = await fetch(base + 'cart.js').then(x => x.json());
      document.querySelectorAll('.xn-header__tools a[href$="/cart"]').forEach(a => { a.textContent = 'Cart (' + cart.item_count + ')'; });
      msg.innerHTML = 'Added. <a class="xn-link" href="' + base + 'cart">View cart</a>';
    } catch (e) {
      msg.textContent = e.message || 'Could not add to cart. Try again.';
    }
    btn.disabled = false; btn.textContent = 'Add to cart';
  }

  W.renderPage = async function (root) {
    const grid = root.querySelector('[data-xn-wish-grid]');
    const empty = root.querySelector('[data-xn-wish-empty]');
    const list = read();
    if (!list.length) { grid.innerHTML = ''; grid.hidden = true; empty.hidden = false; return; }
    const base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const found = await Promise.all(list.map(h =>
      fetch(base + 'products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
        .then(r => (r.ok ? r.json() : null)).catch(() => undefined)
    ));
    // A piece that no longer exists (404) drops off the list; a network failure keeps it.
    const gone = list.filter((h, i) => found[i] === null);
    if (gone.length) write(read().filter(h => !gone.includes(h)));
    const products = found.filter(Boolean);
    if (!products.length) { grid.innerHTML = ''; grid.hidden = true; empty.hidden = false; return; }
    grid.innerHTML = products.map(p => card(p, root.dataset.moneyFormat)).join('');
    grid.hidden = false;
    empty.hidden = true;
  };

  function renderPages() { document.querySelectorAll('[data-xn-wishlist-page]').forEach(W.renderPage); }

  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-xn-wish]');
    if (btn) { e.preventDefault(); W.toggle(btn.dataset.xnWish); return; }
    const add = e.target.closest('[data-xn-wish-add]');
    if (add) { e.preventDefault(); addToCart(add.closest('[data-xn-wish-buy]')); return; }
    const rm = e.target.closest('[data-xn-wish-remove]');
    if (rm) {
      e.preventDefault();
      W.remove(rm.dataset.xnWishRemove);
      const li = rm.closest('.xn-wishcard');
      const root = rm.closest('[data-xn-wishlist-page]');
      if (li) li.remove();
      if (root && !read().length) { root.querySelector('[data-xn-wish-grid]').hidden = true; root.querySelector('[data-xn-wish-empty]').hidden = false; }
    }
  });
  document.addEventListener('change', e => {
    const sel = e.target.closest('select[data-xn-wish-variant]');
    if (!sel) return;
    const box = sel.closest('[data-xn-wish-buy]');
    const btn = box.querySelector('[data-xn-wish-add]');
    btn.disabled = !sel.value;
    btn.textContent = sel.value ? 'Add to cart' : 'Select a size';
    box.querySelector('[data-xn-wish-msg]').textContent = '';
  });
  // Another tab changed the list
  window.addEventListener('storage', e => { if (e.key === KEY) { sync(); renderPages(); } });
  // Theme editor re-renders sections
  document.addEventListener('shopify:section:load', () => { sync(); renderPages(); });

  function start() { sync(); renderPages(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
